import React from "react";
import ContentLoader from "react-content-loader";

const Skeleton = (props) => {
  const { wrapperwidth, wrapperheight, rectwidth, rectheight } = props;
  return (
    <ContentLoader
      speed={1.25}
      width={wrapperwidth}
      height={wrapperheight}
      viewBox={`0 0 ${wrapperwidth} ${wrapperheight}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="0" y="0" rx="3" ry="3" width={rectwidth} height={rectheight} />
      <rect x="0" y="30" rx="3" ry="3" width={rectwidth} height={rectheight} />
      <rect x="0" y="60" rx="3" ry="3" width={rectwidth} height={rectheight} />
    </ContentLoader>
  );
};

export default Skeleton;
